export default __webpack_public_path__ + "static/media/Bradley.cedd7d3f.otf";